import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Input, Modal, Row, Typography} from "antd";
import {useDispatch} from "react-redux";
import {changePassword} from "../../_redux/actions/authAction";
import {SyncOutlined} from "@ant-design/icons";

const ChangePasswordModal = ({visible, setVisible, userInfo}) => {

    const [confirm, setConfirm] = useState(false);
    const [samePw, setSamePw] = useState(false)
    const dispatch = useDispatch();
    const [form] = Form.useForm();
    const {Title} = Typography;

    useEffect(() => {
        form.setFieldsValue({
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
        })
    }, [])

    const onClose = () => {
        setVisible(false);
    }

    const onClickSave = () => {
        form.validateFields().then((value) => {
            dispatch(changePassword({
                "password": value.newPassword
            }, setVisible));
            form.resetFields();
        })
    }

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            title={<Title level={4} style={{margin: '0 0 2rem'}}><SyncOutlined /> Change Password</Title>}
            footer={null}
            maskClosable={false}
        >
            <Form form={form} onFinish={onClickSave} layout='vertical'>
                <Row gutter={24}>
                    <Col span={24}>
                        <Form.Item label='Password' name="oldPassword" rules={[{required: true, message: 'Please Input'}]}>
                            <Input.Password/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label='New Password' name="newPassword" rules={[{required: true, message: 'Please Input'},
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('oldPassword') !== value) {
                                    setSamePw(true);
                                    return Promise.resolve();
                                }
                                setSamePw(false);
                                return Promise.reject((new Error('Same as current password')));
                            }
                        })
                        ]}>
                            <Input.Password/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item label='Confirm Password' name="confirmPassword" rules={[{required: true, message: 'Please Input'},
                            ({ getFieldValue }) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('newPassword') === value) {
                                        setConfirm(true);
                                        return Promise.resolve();
                                    }
                                    setConfirm(false);
                                    return Promise.reject(new Error('Password do not match!'));
                                },
                            }),
                        ]}
                        >
                            <Input.Password/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item>
                            <Button style={{width: '100%', height: '2.5rem', borderRadius: '0.5rem'}} type='primary' disabled={(!confirm || !samePw)} htmlType='submit'>Save</Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ChangePasswordModal;